import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const selectRoot = ({ snackbars }: RootState) => snackbars;

export const selectSnackbars = createSelector(
    selectRoot,
    snackbars => Object.values(snackbars).map(snackbar => snackbar),
);
